import { createStyles } from '../withStyles';
const styles = (theme) => createStyles({
    root: {
        padding: `${theme.spacing(3)}px ${theme.spacing(6)}px`,
    },
});
export default styles;
//# sourceMappingURL=MenuDrawerCTA.styles.js.map